import {ModelInputDetailDTO, parseDate} from 'hemwb-api';

export const sanitizeModelInputDetailDTO = (i: ModelInputDetailDTO): ModelInputDetailDTO => {
  return {
    ...i,
    createdOn: i.createdOn && !(i.createdOn instanceof Date) ? parseDate(i.createdOn) : i.createdOn,
    modifiedOn: i.modifiedOn && !(i.modifiedOn instanceof Date) ? parseDate(i.modifiedOn) : i.modifiedOn || undefined,
  };
};
